<script>
import { SysVars } from "../main";
import { zeroPad } from "../shared/utils";
import {
  apiORDS,
  apiMenuLiberado,
  apiRecursoLiberado,
  apiORDSpost
} from "../shared/api-functions";
import { io } from "socket.io-client";
import NotificationHistory from "./notification-history.vue";
import ConfigGuia from "../forms/config-guia.vue";

export default {
  components: {
    NotificationHistory,
    ConfigGuia
  },
  data() {
    return {
      currVideo: null,
      unreadNotification: 0,
      notification: null,
      offset: false,
      viewMobileMenu: false,
      showNotificationHistory: false,
      backToNotificationHistoryModal: false,
      configGuide: false,
      isGuide: false
    };
  },

  computed: {
    showConsultasAntigas: function () {
      if (SysVars.plano && SysVars.plano.plano_atual && SysVars.plano.plano_atual.controle_app) {
        let appStr = SysVars.plano.plano_atual.controle_app;
        if (appStr.startsWith('ERP')) {
          let num = parseInt(appStr.replace('ERP', ''), 10);
          if (!isNaN(num) && num >= 4) {
            return false;
          }
        }
      }
      return true;
    },
    nextPage: function () {
      return this.$store.getters.getNextPage;
    },

    notificationsList: function () {
      let notifications = [];
      if (
        !this.$store.getters.getNotificationsList ||
        !this.$store.getters.getNotificationsList.length
      )
        return notifications;

      let notifications_status_0 = this.$store.getters.getNotificationsList.filter(
        e => e.status_usuario == "0"
      );

      notifications_status_0.forEach(e => {
        notifications.push(e);
      });
      return notifications;
    },
    notificationMsg: function () {
      const strLineBreak = this.notification.mensagem.replace(/\\n/g, "\n");
      return strLineBreak;
    },
    administrador: function () {
      return SysVars.usuarioAdministrador;
    },
    usuarioForcavendas: function () {
      return SysVars.usuarioForcaVendas;
    },
    company: function () {
      return this.$store.getters.getEnv.empresacod;
    },
    uuid: function () {
      return this.$store.getters.getEnv.uuid;
    },
    usuarionome: function () {
      return this.$store.getters.getEnv.usuarionome;
    },
    empresanome: function () {
      return this.$store.getters.getEnv.empresanome;
    },
    empresacod: function () {
      return zeroPad(this.$store.getters.getEnv.empresacod, 6);
    },
    email: function () {
      return this.$store.getters.getEnv.email;
    },
    istrial: function () {
      return this.$store.getters.getSessao.istrial == "S";
    },
    appNFe: function () {
      return SysVars.appNFe;
    },
    appERP: function () {
      return SysVars.appERP;
    },
    appForcaVendas: function () {
      return SysVars.appForcaVendas;
    },
    isAdmin: function () {
      return SysVars.usuarioAdministrador;
    },
    hasRep: function () {
      return SysVars.hasRepresentation;
    },
    isRep: function () {
      return SysVars.usuarioForcaVendas;
    },
    isUserVarejoPDV: function () {
      return SysVars.usuarioVarejoPDV;
    },

    menu: function () {
      if (SysVars.usuarioForcaVendas) return "menuforcavendas";
      else if (this.isUserVarejoPDV) return "menuvarejopdv";
      else if (SysVars.appNFe) return "menucompleto";
      else if (SysVars.appVarejo) return "menucompleto";
      else if (
        (SysVars.appERP && SysVars.usuarioForcaVendas) ||
        SysVars.appForcaVendas
      )
        return "menuforcavendas";
      else if (SysVars.appERP) return "menucompleto";
    },
    appLoja: function () {
      return SysVars.appLoja;
    },
    app: function () {
      if (SysVars.appNFe) return "nfe";
      else if (SysVars.appForcaVendas) return "forcaVendas";
      else if (SysVars.appVarejo) return "varejo";
      else if (SysVars.appERP) return "erp";
    },
    url_router: function () {
      return this.$route.name;
    },

    helpList: function () {
      let list = this.$store.getters.getHelpList;
      return list.filter(obj => {
        return (
          !obj.app ||
          (obj.app.indexOf(this.app) > -1 && obj.route == this.url_router)
        );
      });
    },
    agendaCounter: function () {
      return SysVars.countAgenda;
    },
    emailCounter: function () {
      return SysVars.countEmail;
    },
    classDesktopMobile: function () {
      return "navbar-desktop";
      if (this.appForcaVendas) {
        return "navbar-desktop";
      } else {
        return "navbar-desktop navbar-mobile";
      }
    },
    planoConsultasComercial: function () {
      const isValid = apiRecursoLiberado(this, "consultascomercial");
      return isValid;
    },
    planoConsultasEstoque: function () {
      const isValid = apiRecursoLiberado(this, "consultasestoque");
      return isValid;
    },
    planoConsultasFinanceiro: function () {
      const isValid = apiRecursoLiberado(this, "consultasfinanceiro");
      return isValid;
    }
  },

  methods: {
    handleCancelNotification(not) {
      this.notification = not;
      this.handleConfirmNotification();
    },
    handleShowNotificationHistory() {
      this.showNotificationHistory = true;
    },
    handleCloseNotification() {
      this.notification = null;

      if (this.backToNotificationHistoryModal) {
        this.showNotificationHistory = true;
        this.backToNotificationHistoryModal = false;
      }
    },
    handleShowViewNotification(value) {
      this.notification = value;
      this.showNotificationHistory = false;
      this.backToNotificationHistoryModal = true;
    },
    handleCloseNotificationHistory() {
      this.showNotificationHistory = false;
    },
    async loadNotifications(next) {
      if (next) {
        this.offset = next;
      }

      let params = {};
      if (this.offset) {
        params.offset = this.nextPage;
      }

      await this.$store.dispatch("loadNotificationsList", params);
      this.offset = false;
    },

    clickAction(action) {
      this.$emit("action", action);
    },

    menuLiberado(recurso) {
      return apiMenuLiberado(this, recurso);
    },

    handleManual() {
      window.open(
        "https://s3.amazonaws.com/htdti/Gestor/NBManual.pdf",
        "_blank"
      );
    },

    handleCentral() {
      window.open("http://notabrasil.com.br/suporte/", "_blank");
    },

    handleLogout() {
      this.$emit("logout");
    },

    handleAssinar() {
      this.$router.push("/assinar");
    },

    handleGuia() {
      if (SysVars.appLoja) this.$router.push("/guialoja");
      else if (SysVars.appNFe) this.$router.push("/guianfe");
      else if (SysVars.appForcaVendas) this.$router.push("/guiapedidos");
      else this.$router.push("/");
    },

    handleShowVideo(index) {
      this.currVideo = this.helpList[index].url;
    },

    iconNotifications(notification) {
      if (notification.status_usuario == "0") return "fa-envelope";
      if (notification.status_usuario == "1") return "fa-envelope-open";
    },

    handleNotifications(notification) {
      this.notification = notification;
    },

    async handleConfirmNotification() {
      this.notification.status_usuario = "1";
      let modulo = "cg/notifications/";
      const data = await apiORDSpost(
        this.$store,
        modulo,
        this.notification,
        "post"
      );

      if (data.resultado) {
        this.$erpToastError("Falha ao confirmar Mensagem!");
        return;
      }

      this.notification = null;

      await this.loadNotifications();
      this.unreadNotification--;

      if (this.unreadNotification < 0) {
        this.unreadNotification = 0;
      }

      if (this.backToNotificationHistoryModal) {
        this.showNotificationHistory = true;
        this.backToNotificationHistoryModal = false;
      }
    },

    toggleMenu() {
      this.viewMobileMenu = !this.viewMobileMenu;
    },

    handleAccordion() {
      const acc = document.getElementsByClassName("accordion");

      for (let i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", event => {
          this.closeAccordions(i);

          acc[i].classList.toggle("active");

          const panel = acc[i].nextElementSibling;

          if (panel.style.maxHeight === "0px") {
            panel.style.maxHeight = "500px";
          } else {
            panel.style.maxHeight = "0px";
          }

          const icon = acc[i].getElementsByClassName("fa");

          if (icon[0].classList.contains("fa-plus")) {
            icon[0].classList.remove("fa-plus");
            icon[0].classList.add("fa-minus");
            return;
          }

          if (icon[0].classList.contains("fa-minus")) {
            icon[0].classList.remove("fa-minus");
            icon[0].classList.add("fa-plus");
            return;
          }
        });
      }
    },

    closeAccordions(index) {
      const acc = document.getElementsByClassName("accordion");

      for (let i = 0; i < acc.length; i++) {
        if (i != index) {
          const panel = acc[i].nextElementSibling;

          if (panel && panel.style.maxHeight === "500px") {
            panel.style.maxHeight = "0px";
          }

          const icon = acc[i].getElementsByClassName("fa");

          if (icon[0].classList.contains("fa-minus")) {
            icon[0].classList.remove("fa-minus");
            icon[0].classList.add("fa-plus");
          }
        }
      }
    },

    handleMenuLink() {
      const link = document.getElementsByClassName("menu-link");

      for (let i = 0; i < link.length; i++) {
        link[i].addEventListener("click", event => {
          this.viewMobileMenu = false;
          this.closeAccordions();
        });
      }
    },

    async loadFilial() {
      await apiORDS(
        this.$store.getters.urlOrds + "cg/filial/varejo",
        null,
        true
      ).then(result => {
        if (result.items.length > 0) {
          this.filial = result.items[0];
          // this.loadLogoTipo();
        }
      });
    },

    handleConfigModal() {
      this.configGuide = !this.configGuide;
    }
  },

  created() {
    let self = this;

    // console.log(this.$store.getters.urlNotifications)
    // //const socket = io("http://ec2-52-202-145-226.compute-1.amazonaws.com:3232", {
    // const socket = io(this.$store.getters.urlNotifications, {
    //     extraHeaders: {
    //         "company": self.company,
    //         "uuid": self.uuid
    //       }
    //   });

    // socket.on("connect", () => {
    //   console.log(socket.id); // x8WIv7-mJelg7on_ALbx

    // });

    // socket.on('notifications', (data) => {
    //   self.unreadNotification = data.qtd
    //   self.loadNotifications();
    // });

    // socket.on("disconnect", () => {
    //   console.log(socket.id); // undefined
    // });
  },

  async mounted() {
    let self = this;

    self.loadNotifications().then(function () {
      let notification = self.notificationsList.find(notification => {
        return (
          notification.status === "1" && notification.status_usuario === "0"
        );
      });
      if (notification) self.notification = notification;
    });

    await this.loadFilial();

    this.handleAccordion();
    this.handleMenuLink();
  }
};
</script>

<template>
  <header :tabindex="1">
    <!-- NAVBAR DESKTOP -->
    <nav :class="classDesktopMobile" class="navbar navbar-expand-lg navbar-light"
      style="background-color: white; border-bottom: 1px solid #e9e5e5;">
      <a class="navbar-brand mt-n2" href="/">
        <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo1.png" style="height: 30px" />
      </a>

      <!-- MENU DOS APLICATIVOS: PEDIDOS, LOJA ON LINE OU USUARIO TIPO FORCA DE VENDAS -->
      <!-- <ul v-if="menu=='menuforcavendas'" class="navbar-nav nb-dropdownmenu mr-auto"> -->
      <ul v-if="menu == 'menuforcavendas'" class="navbar-nav nb-dropdownmenu w-100">
        <div class="w-100 mt-2 mb-2 mobile-device">
          <span class="submenu-header">
            {{ usuarionome }}
          </span>
          <span class="submenu-header">
            {{ email }}
          </span>
        </div>
        <div class="ml-md-auto"></div>
        <li>
          <a href="#/"><i class="fa fa-bar-chart" style="font-size: 18px" aria-hidden="true"></i>
            Início
          </a>
        </li>
        <li>
          <router-link to="/fv/produtos"><i class="fa fa-archive pr-2" aria-hidden="true" style="font-size: 18px"></i>
            Produtos</router-link>
        </li>
        <li>
          <router-link to="/fv/clientes"><i class="fa fa-university pr-2" aria-hidden="true"
              style="font-size: 18px"></i>
            Clientes</router-link>
        </li>

        <li>
          <router-link to="/fv/pedidos"><i class="fa fa-money pr-2" aria-hidden="true" style="font-size: 18px"></i>
            Vendas</router-link>
        </li>

        <li>
          <router-link to="/configuracoes"><i class="fa fa-cog pr-2" aria-hidden="true" style="font-size: 18px"></i>
          </router-link>
        </li>
        <li v-if="appLoja">
          <router-link to="/loja"><i class="fa fa-shopping-basket" aria-hidden="true" style="font-size: 18px"></i>
          </router-link>
        </li>

        <div class="ml-md-auto"></div>

        <li class="other-device float-right">
          <a href="#" class="nb-menu-config">
            <i class="fa fa-question-circle mt-2" aria-hidden="true" style="font-size: 25px;"></i>
          </a>
          <ul id="submenu" class="columns-2 submenu-right">
            <ul>
              <!-- <li><a href="#" @click="handleManual">Manual do Nota Brasil</a></li> -->
              <!-- <li><a href="#" @click="handleCentral">Suporte por Chat</a></li> -->
              <li>
                <a href="#" @click="handleGuia"><i class="fa fa-mortar-board pr-3" style=""></i>Guia
                  Primeiros Passos</a>
              </li>
              <li v-for="(help, index) in helpList" :key="index">
                <a href="#" @click="handleShowVideo(index)"><i class="fa fa-youtube-play nb-help-video-icon"
                    aria-hidden="true"></i>{{ help.title }}</a>
              </li>
            </ul>
          </ul>
        </li>
        <li class="other-device float-right">
          <a href="#">
            <i class="fa fa-user-circle nb-menu-config mt-2" aria-hidden="true" style="font-size: 25px"></i>
          </a>
          <ul id="submenu" class="columns-1 submenu-right">
            <ul>
              <span class="menu-user d-flex py-2">
                <i class="fa fa-user-circle" aria-hidden="true" style="font-size: 3.5rem;"></i>
                <div class="d-flex flex-column justify-content-center align-items-start ml-2">
                  <span>{{ usuarionome }}</span>
                  <span>{{ email }}</span>
                  <span>Cod. Empresa: {{ empresacod }}</span>
                </div>
              </span>
              <span class="menu-email text-uppercase">
                <i class="fa fa-university" aria-hidden="true"></i>
                {{ empresanome }}
              </span>
              <span class="menu-email text-uppercase" id="btn-exit" style="cursor: pointer;" @click="handleLogout">
                <i class="fa fa-sign-out" aria-hidden="true"></i>
                Sair
              </span>
            </ul>
          </ul>
        </li>
        <div class="dropdown-divider mobile-device"></div>
        <li class="mobile-device">
          <a href="#" @click="handleLogout">Sair</a>
        </li>
        <li class="mobile-device">
          <a href="#" @click="handleCentral">Central de Ajuda</a>
        </li>
      </ul>

      <!-- MENU DOS APLICATIVOS:  USUARIO TIPO VAREJO PDV -->
      <ul v-if="menu == 'menuvarejopdv'" class="navbar-nav nb-dropdownmenu w-100">
        <div class="w-100 mt-2 mb-2 mobile-device">
          <span class="submenu-header">
            {{ usuarionome }}
          </span>
          <span class="submenu-header">
            {{ email }}
          </span>
        </div>
        <div class="ml-md-auto"></div>
        <li>
          <a href="#/"><i class="fa fa-bar-chart" style="font-size: 18px" aria-hidden="true"></i>
            Início
          </a>
        </li>
        <li>
          <router-link to="/fv/produtos"><i class="fa fa-archive pr-2" aria-hidden="true" style="font-size: 18px"></i>
            Produtos</router-link>
        </li>
        <li>
          <router-link to="/fv/clientes"><i class="fa fa-university pr-2" aria-hidden="true"
              style="font-size: 18px"></i>
            Clientes</router-link>
        </li>

        <li>
          <a href="#">Varejo</a>
          <ul id="submenu" class="columns-2">
            <div class="row">
              <div class="submenu-col-2">
                <ul>
                  <div class="nb-menu-title custom-text-shadow font-weight-bold ml-n2">
                    Movimentos
                  </div>
                  <li>
                    <router-link to="/varejo">PDV</router-link>
                  </li>
                  <li>
                    <router-link to="/varejolist">Vendas Frente de Caixa</router-link>
                  </li>
                  <li>
                    <router-link to="/varejo/devolucaolist">Devolução de Venda</router-link>
                  </li>
                  <li>
                    <router-link to="/varejo/controlecaixa">Controle de Caixas</router-link>
                  </li>
                </ul>
              </div>
              <div class="submenu-col-2 left-divider pl-2">
                <ul>
                  <div class="nb-menu-title font-weight-bold ml-n2">
                    Consultas
                  </div>
                  <li>
                    <router-link to="/consultas/varejo-movimento-caixa">Consulta Fechamento de Caixa</router-link>
                  </li>
                  <li>
                    <router-link to="/varejo/recebiveis">Consulta Recebiveis</router-link>
                  </li>
                  <div class="nb-menu-title font-weight-bold ml-n2">
                    Cadastros
                  </div>
                  <li>
                    <router-link to="/fpag">Formas de Pagamento</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </ul>
        </li>

        <li>
          <router-link to="/configuracoes"><i class="fa fa-cog pr-2" aria-hidden="true" style="font-size: 18px"></i>
          </router-link>
        </li>

        <div class="ml-md-auto"></div>

        <li class="other-device float-right">
          <a href="#" class="nb-menu-config">
            <i class="fa fa-question-circle mt-2" aria-hidden="true" style="font-size: 25px;"></i>
          </a>
          <ul id="submenu" class="columns-2 submenu-right">
            <ul>
              <!-- <li><a href="#" @click="handleManual">Manual do Nota Brasil</a></li> -->
              <!-- <li><a href="#" @click="handleCentral">Suporte por Chat</a></li> -->
              <li>
                <a href="#" @click="handleGuia"><i class="fa fa-mortar-board pr-3" style=""></i>Guia
                  Primeiros Passos</a>
              </li>
              <li v-for="(help, index) in helpList" :key="index">
                <a href="#" @click="handleShowVideo(index)"><i class="fa fa-youtube-play nb-help-video-icon"
                    aria-hidden="true"></i>{{ help.title }}</a>
              </li>
            </ul>
          </ul>
        </li>
        <li class="other-device float-right">
          <a href="#">
            <i class="fa fa-user-circle nb-menu-config mt-2" aria-hidden="true" style="font-size: 25px"></i>
          </a>
          <ul id="submenu" class="columns-1 submenu-right">
            <ul>
              <span class="menu-user d-flex py-2">
                <i class="fa fa-user-circle" aria-hidden="true" style="font-size: 3.5rem;"></i>
                <div class="d-flex flex-column justify-content-center align-items-start ml-2">
                  <span>{{ usuarionome }}</span>
                  <span>{{ email }}</span>
                  <span>Cod. Empresa: {{ empresacod }}</span>
                </div>
              </span>
              <span class="menu-email text-uppercase">
                <i class="fa fa-university" aria-hidden="true"></i>
                {{ empresanome }}
              </span>
              <span class="menu-email text-uppercase" id="btn-exit" style="cursor: pointer;" @click="handleLogout">
                <i class="fa fa-sign-out" aria-hidden="true"></i>
                Sair
              </span>
            </ul>
          </ul>
        </li>
        <div class="dropdown-divider mobile-device"></div>
        <li class="mobile-device">
          <a href="#" @click="handleLogout">Sair</a>
        </li>
        <li class="mobile-device">
          <a href="#" @click="handleCentral">Central de Ajuda</a>
        </li>
      </ul>

      <!-- MENU DOS APLICATIVOS: NFE, ERP, VAREJO -->
      <div class="d-flex justify-content-between align-items-center w-100" v-if="menu == 'menucompleto'">
        <div class="nb-dropdownmenu">
          <ul>
            <li>
              <a href="#/">Início</a>
            </li>
            <li>
              <a href="#">Cadastros</a>
              <ul id="submenu" class="columns-1">
                <ul>
                  <div class="nb-menu-title font-weight-bold ml-n2">
                    Principais
                  </div>
                  <li>
                    <router-link to="/fv/produtos">Produtos</router-link>
                  </li>
                  <li>
                    <router-link to="/partlist">Participantes
                      <span><small>Clientes/Fornecedores/Transportadoras</small></span>
                    </router-link>
                  </li>
                  <div class="nb-menu-title font-weight-bold ml-n2">
                    Básicos
                  </div>
                  <li v-if="administrador">
                    <router-link to="/importaxml">Importar Cadastros por XML</router-link>
                  </li>
                </ul>
                <!--
                  <div class="submenu-col-2 left-divider">
                    <ul>
                    </ul>
                  </div>
                  -->
              </ul>
            </li>

            <!-- COMERCIAL -->
            <li v-if="appERP || appForcaVendas">
              <a href="#">Pedidos</a>
              <ul id="submenu" class="columns-2">
                <div class="row">
                  <div class="submenu-col-2">
                    <ul>
                      <div class="nb-menu-title custom-text-shadow font-weight-bold ml-n2">
                        Movimentos
                      </div>
                      <!-- <li><router-link to="/pedidolist">Pedidos</router-link></li> -->
                      <li>
                        <router-link :to="appERP ? '/pedidolist' : '/fv/pedidos'">Pedidos de Venda</router-link>
                      </li>
                      <li>
                        <router-link to="/compralist">Pedidos de Compra</router-link>
                      </li>
                      <li v-if="appERP">
                        <router-link to="/fv/pedidos" v-if="(isAdmin && hasRep) || isRep">Gestão Representante
                        </router-link>
                      </li>
                    </ul>
                  </div>
                  <div v-if="planoConsultasComercial" class="submenu-col-2 left-divider pl-2">
                    <ul>
                      <div class="nb-menu-title font-weight-bold ml-n2">
                        Consultas
                      </div>
                      <li>
                        <router-link to="/consultas/carteiraclientes">Carteira de clientes</router-link>
                      </li>
                      <li>
                        <router-link to="/consultas/vendas-performance-carteira">Performance da carteira</router-link>
                      </li>
                      <li>
                        <router-link to="/consultas/curvacliente">Curva ABC de clientes</router-link>
                      </li>
                      <li>
                        <router-link to="/consultas/vendas-por-cliente">Vendas por cliente</router-link>
                      </li>
                      <li>
                        <router-link to="/consultas/lista-clientes">Listagem de clientes</router-link>
                      </li>
                      <li>
                        <router-link to="/consultas/vendas-vendedor">Ranking de vendedores</router-link>
                      </li>
                      <li>
                        <router-link to="/consultas/vendas">Consulta Vendas</router-link>
                      </li>
                      <li>
                        <router-link to="/consultas/vendas-produtos">Produtos vendidos</router-link>
                      </li>
                      <li>
                        <router-link to="/consultas/vendas-pedidos-produto">Pedidos por produto</router-link>
                      </li>
                      <li>
                        <router-link to="/consultas/vendas-pedidos-faturados">Pedidos faturados</router-link>
                      </li>
                      <li>
                        <router-link to="/consultas/vendas-pedidos-comissao-por-pedido">Comissão por Pedido
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </ul>
            </li>

            <!-- <li v-if="menuLiberado('varejo')"> -->
            <li v-if="appERP">
              <a href="#">Varejo</a>
              <ul id="submenu" class="columns-2">
                <div class="row">
                  <div class="submenu-col-2">
                    <ul>
                      <div class="nb-menu-title custom-text-shadow font-weight-bold ml-n2">
                        Movimentos
                      </div>
                      <li>
                        <router-link to="/varejo">PDV</router-link>
                      </li>
                      <li>
                        <router-link to="/varejolist">Vendas Frente de Caixa</router-link>
                      </li>
                      <li>
                        <router-link to="/varejo/devolucaolist">Devolução de Venda</router-link>
                      </li>
                      <li>
                        <router-link to="/varejo/controlecaixa">Controle de Caixas</router-link>
                      </li>
                    </ul>
                  </div>
                  <div class="submenu-col-2 left-divider pl-2">
                    <ul>
                      <div class="nb-menu-title font-weight-bold ml-n2">
                        Consultas
                      </div>
                      <li>
                        <router-link to="/consultas/varejo-movimento-caixa">Consulta Fechamento de Caixa</router-link>
                      </li>
                      <li>
                        <router-link to="/varejo/recebiveis">Consulta Recebiveis</router-link>
                      </li>
                      <div class="nb-menu-title font-weight-bold ml-n2">
                        Cadastros
                      </div>
                      <li>
                        <router-link to="/fpag">Formas de Pagamento</router-link>
                      </li>
                      <li>
                        <router-link to="/caixas">Caixas PDV</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </ul>
            </li>

            <!-- FATURAMENTO -->
            <li v-if="appERP || appNFe">
              <a href="#">Faturamento</a>
              <ul id="submenu" class="columns-2">
                <div class="row">
                  <div class="submenu-col-2">
                    <ul>
                      <div class="nb-menu-title custom-text-shadow font-weight-bold ml-n2">
                        Movimentos
                      </div>
                      <li>
                        <router-link to="/nflist/saida">Notas de Saída</router-link>
                      </li>
                      <li>
                        <router-link to="/nflist/entrada">Notas de Entrada</router-link>
                      </li>
                      <li>
                        <router-link to="/nfimportlist">Notas de Importação</router-link>
                      </li>
                      <li>
                        <router-link to="/duimplist">DUIMP (Siscomex)</router-link>
                      </li>
                    </ul>
                  </div>
                  <div class="submenu-col-2 left-divider pl-2">
                    <ul>
                      <div class="nb-menu-title font-weight-bold ml-n2">
                        Outras Rotinas
                      </div>
                      <li>
                        <router-link to="/manifesto">Manifestação Destinatário</router-link>
                      </li>
                      <li>
                        <router-link to="/inutlist">Inutilizar Numeração</router-link>
                      </li>
                      <li>
                        <router-link to="/mennflist">Mensagens Para NF</router-link>
                      </li>
                      <li>
                        <router-link to="/ivancmlist">NCM x CST-IBS/CBS</router-link>
                      </li>

                      <li v-if="administrador">
                        <router-link to="/importaxmlhist">Importar NF-e por XML</router-link>
                      </li>
                      <div v-if="appERP || appNFe" class="nb-menu-title font-weight-bold ml-n2">
                        Relatórios
                      </div>
                      <li v-if="appERP || appNFe">
                        <router-link to="/printform">Notas e Pedidos</router-link>
                      </li>
                      <li v-if="appERP || appNFe">
                        <router-link to="/consultas/distribuicaocfop">Distribuição por CFOP</router-link>
                      </li>
                      <li v-if="(appERP || appNFe) && showConsultasAntigas">
                        <router-link to="/estoque/saldoentradasaida">Saldo Entradas/Saídas</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </ul>
            </li>

            <!-- ESTOQUE -->
            <li v-if="menuLiberado('estoque')">
              <a href="#">Estoque</a>
              <ul id="submenu" class="columns-2">
                <div class="row">
                  <div class="submenu-col-2">
                    <ul>
                      <div class="nb-menu-title custom-text-shadow font-weight-bold ml-n2">
                        Movimentos
                      </div>
                      <li>
                        <router-link to="/importa/estoque">Importar Estoque</router-link>
                      </li>
                      <li>
                        <router-link to="/consultas/estoque-produto">Consulta Estoque do Produto</router-link>
                      </li>
                      <li v-if="showConsultasAntigas">
                        <router-link to="/consultas/items-estoque">Consulta Estoque Atual</router-link>
                      </li>
                      <div class="nb-menu-title custom-text-shadow font-weight-bold ml-n2">
                        Básicos
                      </div>
                      <li>
                        <router-link to="/depolist">Depósito</router-link>
                      </li>
                    </ul>
                  </div>
                  <div v-if="planoConsultasEstoque" class="submenu-col-2 left-divider pl-2">
                    <ul>
                      <div class="nb-menu-title font-weight-bold ml-n2">
                        Consultas
                      </div>
                      <li>
                        <router-link to="/consultas/estoque-saldo">Consulta Saldo Estoque</router-link>
                      </li>
                      <li>
                        <router-link to="/consultas/entrada-e-saida">Movimentos de Entradas e Saídas</router-link>
                      </li>
                      <li>
                        <router-link to="/consultas/resumo-entrada-e-saida">Resumo de Entradas e Saídas</router-link>
                      </li>
                      <li v-if="showConsultasAntigas">
                        <router-link to="/estoque/saldoentradasaida">Saldo Entradas/Saídas</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </ul>
            </li>

            <!-- VAREJO -->


            <!-- FINANCEIRO -->
            <li v-if="menuLiberado('financeiro')">
              <a href="#">Financeiro</a>
              <ul id="submenu" class="columns-2">
                <div class="row">
                  <div class="submenu-col-2">
                    <ul>
                      <div class="nb-menu-title custom-text-shadow font-weight-bold ml-n2">
                        Movimentos
                      </div>
                      <li>
                        <router-link to="/financeiro">Painel Financeiro</router-link>
                      </li>
                      <li>
                        <router-link to="/cnab">Arquivos de Cobrança</router-link>
                      </li>
                      <li>
                        <router-link to="/banking">Cobrança Banking</router-link>
                      </li>
                      <!-- <li><router-link to="/financeirolog">Histórico de Alterações</router-link></li> -->
                      <div v-if="planoConsultasFinanceiro" class="nb-menu-title font-weight-bold ml-n2">
                        Consultas
                      </div>
                      <li v-if="planoConsultasFinanceiro">
                        <router-link to="/financeiro/posicaofinanceiro">Posição do Financeiro</router-link>
                      </li>
                      <li v-if="planoConsultasFinanceiro">
                        <router-link to="/financeiro/financeirobaixas">Consulta Baixas</router-link>
                      </li>
                      <li v-if="planoConsultasFinanceiro">
                        <router-link to="/financeiro/fluxodecaixa">Fluxo de Caixa</router-link>
                      </li>
                      <li v-if="planoConsultasFinanceiro">
                        <router-link to="/financeiro/dre">Consulta DRE</router-link>
                      </li>
                    </ul>
                  </div>
                  <div class="submenu-col-2 left-divider pl-2">
                    <ul>
                      <div class="nb-menu-title font-weight-bold ml-n2">
                        Cadastros
                      </div>
                      <li>
                        <router-link to="/cta">Contas</router-link>
                      </li>
                      <li>
                        <router-link to="/natfinlist">Natureza Financeira</router-link>
                      </li>
                      <li>
                        <router-link to="/fpag">Formas de Pagamento</router-link>
                      </li>
                      <li>
                        <router-link to="/cobranca-config">Configuração de Cobrança</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </ul>
            </li>

            <!-- CRM -->
            <!-- <li v-if="menuLiberado('crm')"> -->
            <li v-if="false">
              <a href="#">CRM</a>
              <ul id="submenu" class="columns-1">
                <ul>
                  <li>
                    <router-link to="/crm/lead/list"><i class="fa fa-exclamation pr-2" aria-hidden="true"
                        style="font-size: 18px; width: 25px"></i>
                      Leads</router-link>
                  </li>
                  <li>
                    <router-link to="/crm/pessoa/list"><i class="fa fa-user pr-2" aria-hidden="true"
                        style="font-size: 18px; width: 25px"></i>
                      Contatos</router-link>
                  </li>
                  <li>
                    <router-link to="/crm/organizacao/list"><i class="fa fa-university pr-2" aria-hidden="true"
                        style="font-size: 18px; width: 25px"></i>
                      Organizações</router-link>
                  </li>
                  <li>
                    <router-link to="/crm/painel"><i class="fa fa-dollar pr-2" aria-hidden="true"
                        style="font-size: 18px; width: 25px"></i>
                      Negócios</router-link>
                  </li>
                  <li>
                    <router-link to="/crm/config"><i class="fa fa-cog pr-2" aria-hidden="true"
                        style="font-size: 18px; width: 25px"></i>
                      Configurações</router-link>
                  </li>
                  <!-- <li> -->
                  <!--   <router-link to="/fv/agenda"><i class="fa fa-calendar pr-2" aria-hidden="true" style="font-size: 18px"></i> <span v-if="agendaCounter" class="counter"> {{ agendaCounter }} </span> Agenda</router-link> -->
                  <!-- </li> -->
                  <!-- <li> -->
                  <!--   <router-link to="/crm/email/list"><i class="fa fa-envelope pr-2" aria-hidden="true" style="font-size: 18px"></i> <span v-if="emailCounter" class="counter"> {{ emailCounter }} </span> Emails</router-link> -->
                  <!-- </li> -->
                </ul>
              </ul>
            </li>

            <!-- CONFIGURACOES -->
            <li>
              <a href="#">Configurações</a>
              <ul id="submenu" class="columns-2 submenu-right">
                <div class="row">
                  <div class="submenu-col-2">
                    <ul>
                      <div class="nb-menu-title font-weight-bold ml-n2">
                        Configurações Gerais
                      </div>
                      <li v-if="administrador && !isGuide">
                        <router-link to="/configuracoes">Configurações da Conta</router-link>
                      </li>
                      <li v-if="administrador && isGuide">
                        <a @click="handleConfigModal" style="cursor: pointer;">
                          Configurações da Conta</a>
                      </li>
                      <li v-if="administrador">
                        <router-link to="/filiallist/certificado">Certificado Digital</router-link>
                      </li>
                      <!-- CONFIGURACOES -->
                      <li v-if="administrador && hasRep">
                        <router-link to="/configuracoes">Config. Força de Vendas
                        </router-link>
                      </li>
                      <li v-if="administrador">
                        <router-link to="/minhaconta">Minha Conta </router-link>
                      </li>
                      <!-- CONFIGURACOES LOJA -->
                      <li v-if="administrador && appLoja">
                        <router-link to="/loja">Config. Loja </router-link>
                      </li>
                    </ul>
                  </div>
                  <div class="submenu-col-2 left-divider pl-2">
                    <ul>
                      <div class="nb-menu-title font-weight-bold ml-n2">
                        Cadastros
                      </div>
                      <li>
                        <router-link to="/nateslist">Natureza Entrada e Saída</router-link>
                      </li>
                      <li>
                        <router-link to="/serienflist">Séries de Nota Fiscal</router-link>
                      </li>
                      <div class="nb-menu-title font-weight-bold ml-n2">
                        Consultas
                      </div>

                      <li>
                        <router-link to="/ivaclasslist">CST-IBS/CBS</router-link>
                      </li>


                      <!-- removido do menu para versao inicial de saida -->
                      <!-- <li><router-link to="/catmkt">Categorias Marketplace</router-link></li> -->

                      <!-- <li v-if="acessoCore"><router-link to="/ncmlist">NCM</router-link></li> -->
                      <!-- <li v-if="acessoCore"><router-link to="/importaibpt">Importar tabelas IBPT</router-link></li> -->
                    </ul>
                  </div>
                </div>
              </ul>
            </li>
          </ul>
        </div>

        <!-- ICONES DE NOTIFICACOES, LOGOUT, AJUDA -->
        <div class="menu-icons nb-dropdownmenu w-auto">
          <ul class="list-unstyled d-flex justify-content-end align-items-center">
            <li class="float-right">
              <a href="#" class="nb-menu-config">
                <i :class="{ bell: unreadNotification }" class="fa fa-bell" aria-hidden="true"
                  style="font-size: 20px;"></i>
                <span class="badge badge-danger" id="badge" v-if="unreadNotification">{{ unreadNotification }}</span>
              </a>

              <ul id="submenu" class="columns-1 submenu-right notification">
                <ul v-for="(notification, index) in notificationsList" :key="index">
                  <li>
                    <a href="#" class="notification-text" @click="handleNotifications(notification)">
                      <i class="pr-3 fa" :class="iconNotifications(notification)" style="font-size: 18px"></i>
                      <span class="ml-1">{{
                          notification.codnotificacao
                      }}</span>
                      <span>{{ notification.assunto }}</span>
                    </a>
                  </li>
                </ul>
                <li v-if="nextPage > 0">
                  <a href="#" class="notification-text" @click="loadNotifications(true)">
                    <i class="pr-3 fa fa-plus" style="font-size: 18px"></i>
                    <span>Carregar mais</span>
                  </a>
                </li>
                <button @click="handleShowNotificationHistory()"
                  class="btn text-light flex-row justify-content-end  w-100" style="">
                  <span style="font-size:12px">
                    Exibir histórico de notificações
                  </span>
                  <i class="fa fa-share ml-2"></i>
                </button>
              </ul>
            </li>

            <li class="other-device float-right">
              <a href="#" class="nb-menu-config">
                <i class="fa fa-user mt-2" aria-hidden="true" style="font-size: 22px"></i>
              </a>
              <ul id="submenu" class="columns-1 submenu-right">
                <ul>
                  <span class="menu-user d-flex py-2">
                    <i class="fa fa-user-circle" aria-hidden="true" style="font-size: 3.5rem;"></i>
                    <div class="d-flex flex-column justify-content-center align-items-start ml-2">
                      <span>{{ usuarionome }}</span>
                      <span>{{ email }}</span>
                      <span>Cod. Empresa: {{ empresacod }}</span>
                    </div>
                  </span>
                  <span class="menu-email text-uppercase">
                    <i class="fa fa-university" aria-hidden="true"></i>
                    {{ empresanome }}
                  </span>
                  <span class="menu-email text-uppercase" id="btn-exit" style="cursor: pointer;" @click="handleLogout">
                    <i class="fa fa-sign-out" aria-hidden="true"></i>
                    Sair
                  </span>
                </ul>
              </ul>
            </li>

            <li class="other-device float-right">
              <a href="#" class="nb-menu-config">
                <i class="fa fa-question-circle mt-2" aria-hidden="true" style="font-size: 25px;"></i>
              </a>
              <ul id="submenu" class="columns-3 submenu-right">
                <ul>
                  <!-- <li><a href="#" @click="handleManual">Manual do Nota Brasil</a></li> -->
                  <!--<li><a href="#" @click="handleCentral">Suporte por Chat</a></li>-->
                  <li>
                    <a href="#" @click="handleGuia"><i class="fa fa-mortar-board pr-3" style=""></i>Guia
                      Primeiros Passos</a>
                  </li>
                  <li v-for="(help, index) in helpList" :key="index">
                    <a href="#" @click="handleShowVideo(index)"><i class="fa fa-youtube-play nb-help-video-icon"
                        aria-hidden="true"></i>{{ help.title }}</a>
                  </li>
                </ul>
              </ul>
            </li>

            <div class="dropdown-divider mobile-device"></div>

            <li class="mobile-device">
              <a href="#" @click="handleLogout">Sair</a>
            </li>
            <li class="mobile-device">
              <a href="#" @click="handleCentral">Central de Ajuda</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!--


  NAVBAR MOBILE


-->
    <!-- v-if="appForcaVendas" -->
    <nav class="navbar navbar-mobile bg-white w-100 d-none" style="height: 60px;">
      <div class="d-flex justify-content-start align-items-center">
        <!-- LOGO -->
        <span class="logo mr-3">
          <a class="navbar-brand" href="/">
            <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo1.png"
              style="height: 30px" />
          </a>
        </span>

        <div class="wrapper bg-white d-none" :class="{ active: viewMobileMenu }">
          <!-- MENU COMPLETO MOBILE APPS: NFE, ERP, VAREJO -->
          <div class="menu mb-5" v-if="menu == 'menucompleto'">
            <div class="user-info d-flex justify-content-start align-items-center ml-2 my-3">
              <i class="fa fa-user-circle" aria-hidden="true" style="font-size: 40px"></i>
              <div class="d-flex flex-column ml-3">
                <span class="font-weight-bold">{{ usuarionome }}</span>
                <span class="">{{ email }}</span>
              </div>
            </div>

            <button class="accordion text-uppercase">
              <i class="fa fa-home mr-1" aria-hidden="true" style="font-size: 16px;"></i>
              <a href="#/" class="menu-link text-dark">Início</a>
            </button>

            <button class="accordion text-uppercase">
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>
              Cadastros
            </button>
            <div class="panel" style="max-height: 0">
              <p class="text-secondary font-weight-bold" v-if="appERP || appNFe">
                Principais
              </p>
              <ul class="list-unstyled ml-3">
                <li class="py-2">
                  <router-link class="menu-link text-dark" to="/fv/produtos">Produtos</router-link>
                </li>
                <li class="py-2">
                  <router-link class="menu-link text-dark" to="/partlist">Participantes <small>Cli/Forn/Transp</small>
                  </router-link>
                </li>
              </ul>
              <p v-if="appERP || appNFe" class="text-secondary font-weight-bold">
                Básicos
              </p>
              <ul v-if="appERP || appNFe" class="list-unstyled ml-3">
                <li class="py-2">
                  <router-link class="menu-link text-dark" to="/gruclilist">Grupos de Clientes</router-link>
                </li>
                <li class="py-2">
                  <router-link class="menu-link text-dark" to="/gruforlist">Grupos de Fornecedores</router-link>
                </li>
                <li class="py-2">
                  <router-link class="menu-link text-dark" to="/gradelist">Grades</router-link>
                </li>
                <li class="py-2">
                  <router-link class="menu-link text-dark" to="/mennflist">Mensagens Para NF</router-link>
                </li>
              </ul>
            </div>

            <button class="accordion text-uppercase">
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>
              Movimentos
            </button>
            <div class="panel" style="max-height: 0">
              <p v-if="appERP || appNFe" class="text-secondary font-weight-bold">
                Movimentos
              </p>
              <ul class="list-unstyled ml-3">
                <li v-if="appERP || appNFe" class="py-2">
                  <router-link class="menu-link text-dark" to="/pedidolist">Pedidos de Venda</router-link>
                </li>
                <li v-if="appERP || appNFe" class="py-2">
                  <router-link class="menu-link text-dark" to="/compralist">Pedidos de Compra</router-link>
                </li>
                <li v-if="appForcaVendas" class="py-2">
                  <router-link class="menu-link text-dark" to="/fv/pedidos">Pedidos</router-link>
                </li>
                <li v-if="appERP || appNFe" class="py-2">
                  <router-link class="menu-link text-dark" to="/nflist/saida">Notas de Saída</router-link>
                </li>
                <li v-if="appERP || appNFe" class="py-2">
                  <router-link class="menu-link text-dark" to="/nflist/entrada">Notas de Entrada</router-link>
                </li>
                <li v-if="appERP || appNFe" class="py-2">
                  <router-link class="menu-link text-dark" to="/nfimportlist">Notas de Importação</router-link>
                </li>
                <li v-if="appERP || appNFe" class="py-2">
                  <router-link class="menu-link text-dark" to="/duimplist">DUIMP (Siscomex)</router-link>
                </li>
                <li v-if="appERP || appNFe" class="py-2">
                  <router-link class="menu-link text-dark" to="/manifesto">Manifestação Destinatário</router-link>
                </li>
                <li v-if="appERP || appNFe" class="py-2">
                  <router-link class="menu-link text-dark" to="/inutlist">Inutilizar Numeração</router-link>
                </li>
              </ul>

              <p v-if="appERP || appNFe" class="text-secondary font-weight-bold">
                Relatórios
              </p>
              <ul class="list-unstyled ml-3" v-if="appERP || appNFe">
                <li v-if="showConsultasAntigas" class="py-2 ml-n2">
                  <router-link class="menu-link text-dark" to="/estoque/saldoentradasaida">Saldo Entradas/Saídas
                  </router-link>
                </li>
                <li class="py-2">
                  <router-link class="menu-link text-dark" to="/printform">Notas e Pedidos</router-link>
                </li>
                <li class="py-2">
                  <router-link class="menu-link text-dark" to="/consultas/distribuicaocfop">Distribuição por CFOP</router-link>
                </li>
              </ul>
            </div>

            <button class="accordion text-uppercase">
              <i class="fa fa-cog mr-1" aria-hidden="true"></i>
              Configurações
            </button>
            <div class="panel" style="max-height: 0">
              <p v-if="appERP || appNFe" class="text-secondary font-weight-bold">
                Configuração
              </p>
              <ul class="list-unstyled ml-3">
                <!-- CONFIGURACOES LOJA -->
                <li v-if="administrador && appLoja">
                  <router-link to="/loja">Config. Loja </router-link>
                </li>
                <li v-if="appERP || appNFe" class="py-2">
                  <router-link class="menu-link text-dark text-decoration-none" to="/fv/configuracoes">Configurações da
                    Conta</router-link>
                </li>
                <li v-if="appForcaVendas" class="py-2">
                  <router-link class="menu-link text-dark text-decoration-none" to="/filiallist/certificado">Certificado
                    Digital</router-link>
                </li>
                <li v-if="appERP || appNFe" class="py-2">
                  <router-link class="menu-link text-dark text-decoration-none" to="/minhaconta">Minha Conta
                  </router-link>
                </li>
              </ul>
            </div>

            <button class="accordion text-uppercase">
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>
              Frente de Caixa
            </button>
            <div class="panel" style="max-height: 0">
              <ul class="list-unstyled ml-3">
                <li class="py-2 ml-n2">
                  <router-link class="menu-link text-dark" to="/varejo">Frente de Caixa</router-link>
                </li>
                <li class="py-2 ml-n2">
                  <router-link class="menu-link text-dark" to="/varejolist">Vendas Frente de Caixa</router-link>
                </li>
                <li class="py-2 ml-n2">
                  <router-link class="menu-link text-dark" to="/varejo/devolucaolist">Devolução de Venda</router-link>
                </li>
                <li class="py-2 ml-n2">
                  <router-link class="menu-link text-dark" to="/varejo/controlecaixa">Controle dos Caixas</router-link>
                </li>
                <li class="py-2 ml-n2">
                  <router-link class="menu-link text-dark" to="/consultas/varejo-movimento-caixa">Consulta Fechamento de
                    Caixa</router-link>
                </li>
                <li class="py-2 ml-n2">
                  <router-link class="menu-link text-dark" to="/varejo/recebiveis">Consulta Recebiveis</router-link>
                </li>
                <li class="py-2 ml-n2">
                  <router-link class="menu-link text-dark" to="/fpag">Formas de Pagamento</router-link>
                </li>
              </ul>
            </div>

            <!-- <button class="accordion text-uppercase">
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>
              Notificações
              <span class="badge badge-danger" id="badge-mobile" v-if="unreadNotification">
                <span>{{ unreadNotification  }}</span>
              </span>
            </button>
            <div class="panel" style="max-height: 0">
              <ul class="list-unstyled ml-3" v-for="(notification, index) in notificationsList" :key="index">
                <li class="py-2 ml-n2">
                  <a href="#" class="text-dark" @click="handleNotifications(notification)">
                    {{notification.status_usuario}}
                    <i class="pr-3 fa" :class="iconNotifications(notification)" style="font-size: 18px"></i>
                    {{ notification.assunto }}
                  </a>
                </li>
              </ul>
            </div> -->

            <!-- <button class="accordion text-uppercase">
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>
              Ajuda
            </button>
            <div class="panel" style="max-height: 0">
              <ul class="list-unstyled ml-3">
                <li class="py-2 ml-n2">
                  <a href="#" class="menu-link text-dark" @click="handleGuia">Guia Primeiros Passos</a>
                </li>
                <li class="py-2 ml-n2" v-for="(help, index) in helpList" :key="index">
                  <a href="#" class="menu-link text-dark" @click="handleShowVideo(index)">{{ help.title }}</a>
                </li>
              </ul>
            </div> -->

            <button class="accordion text-uppercase" @click="handleLogout">
              <i class="fa fa-sign-out" aria-hidden="true" style="font-size: 16px;"></i>
              Sair
            </button>
          </div>

          <!-- MENU FORÇA DE VENDAS APPS: PEDIDOS, LOJA ON LINE -->
          <div class="menu mb-5" v-if="menu == 'menuforcavendas'">
            <div class="user-info d-flex justify-content-start align-items-center ml-2 my-3">
              <i class="fa fa-user-circle" aria-hidden="true" style="font-size: 40px"></i>
              <div class="d-flex flex-column ml-3">
                <span class="font-weight-bold">{{ usuarionome }}</span>
                <span class="">{{ email }}</span>
              </div>
            </div>

            <button class="accordion text-uppercase">
              <a href="#/" class="menu-link text-dark">Início</a>
            </button>

            <button class="accordion text-uppercase">
              <router-link class="menu-link text-dark" to="/fv/produtos">Produtos</router-link>
            </button>

            <button class="accordion text-uppercase">
              <router-link class="menu-link text-dark" to="/fv/clientes">Clientes</router-link>
            </button>

            <button class="accordion text-uppercase">
              <router-link class="menu-link text-dark" to="/fv/pedidos">Vendas</router-link>
            </button>

            <button class="accordion text-uppercase">
              <router-link class="menu-link text-dark" to="/configuracoes">Configurações</router-link>
            </button>

            <button class="accordion text-uppercase" v-if="appLoja">
              <router-link class="menu-link text-dark" to="/loja">Configurações Loja</router-link>
            </button>

            <!-- <button class="accordion text-uppercase">
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>
              Ajuda
            </button>
            <div class="panel" style="max-height: 0">
              <ul class="list-unstyled ml-3">
                <li class="py-2 ml-n2">
                  <a href="#" class="menu-link text-dark" @click="handleGuia">Guia Primeiros Passos</a>
                </li>
                <li class="py-2 ml-n2" v-for="(help, index) in helpList" :key="index">
                  <a href="#" class="menu-link text-dark" @click="handleShowVideo(index)">{{ help.title }}</a>
                </li>
              </ul>
            </div> -->

            <button class="accordion text-uppercase" @click="handleLogout">
              <i class="fa fa-sign-out" aria-hidden="true" style="font-size: 16px;"></i>
              Sair
            </button>
          </div>

          <!-- MENU VAREJO PDV  -->
          <div class="menu mb-5" v-if="menu == 'menuvarejopdv'">
            <div class="user-info d-flex justify-content-start align-items-center ml-2 my-3">
              <i class="fa fa-user-circle" aria-hidden="true" style="font-size: 40px"></i>
              <div class="d-flex flex-column ml-3">
                <span class="font-weight-bold">{{ usuarionome }}</span>
                <span class="">{{ email }}</span>
              </div>
            </div>

            <button class="accordion text-uppercase">
              <a href="#/" class="menu-link text-dark">Início</a>
            </button>

            <button class="accordion text-uppercase">
              <router-link class="menu-link text-dark" to="/fv/produtos">Produtos</router-link>
            </button>

            <button class="accordion text-uppercase">
              <router-link class="menu-link text-dark" to="/fv/clientes">Clientes</router-link>
            </button>

            <button class="accordion text-uppercase">
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>
              Frente de Caixa
            </button>
            <div class="panel" style="max-height: 0">
              <ul class="list-unstyled ml-3">
                <li class="py-2 ml-n2">
                  <router-link class="menu-link text-dark" to="/varejo">Frente de Caixa</router-link>
                </li>
                <li class="py-2 ml-n2">
                  <router-link class="menu-link text-dark" to="/varejolist">Vendas Frente de Caixa</router-link>
                </li>
                <li class="py-2 ml-n2">
                  <router-link class="menu-link text-dark" to="/varejo/devolucaolist">Devolução de Venda</router-link>
                </li>
                <li class="py-2 ml-n2">
                  <router-link class="menu-link text-dark" to="/varejo/controlecaixa">Controle dos Caixas</router-link>
                </li>
                <li class="py-2 ml-n2">
                  <router-link class="menu-link text-dark" to="/consultas/varejo-movimento-caixa">Consulta Fechamento de
                    Caixa</router-link>
                </li>
                <li class="py-2 ml-n2">
                  <router-link class="menu-link text-dark" to="/varejo/recebiveis">Consulta Recebiveis</router-link>
                </li>
                <li class="py-2 ml-n2">
                  <router-link class="menu-link text-dark" to="/fpag">Formas de Pagamento</router-link>
                </li>
              </ul>
            </div>

            <button class="accordion text-uppercase">
              <router-link class="menu-link text-dark" to="/configuracoes">Configurações</router-link>
            </button>

            <button class="accordion text-uppercase" v-if="appLoja">
              <router-link class="menu-link text-dark" to="/loja">Configurações Loja</router-link>
            </button>

            <!-- <button class="accordion text-uppercase">
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>
              Ajuda
            </button>
            <div class="panel" style="max-height: 0">
              <ul class="list-unstyled ml-3">
                <li class="py-2 ml-n2">
                  <a href="#" class="menu-link text-dark" @click="handleGuia">Guia Primeiros Passos</a>
                </li>
                <li class="py-2 ml-n2" v-for="(help, index) in helpList" :key="index">
                  <a href="#" class="menu-link text-dark" @click="handleShowVideo(index)">{{ help.title }}</a>
                </li>
              </ul>
            </div> -->

            <button class="accordion text-uppercase" @click="handleLogout">
              <i class="fa fa-sign-out" aria-hidden="true" style="font-size: 16px;"></i>
              Sair
            </button>
          </div>
        </div>
      </div>

      <!-- MENU HAMBURGER -->
      <span class="hamburger float-right d-none" :class="{ active: viewMobileMenu }" @click="toggleMenu">
        <div class="line-menu half start"></div>
        <div class="line-menu"></div>
        <div class="line-menu half end"></div>
      </span>
    </nav>

    <!-- VIDEOS DE AJUDA -->
    <transition name="fade">
      <div v-if="currVideo" class="guia-video" @click="currVideo = null">
        <div class="guia-video-content text-center" style="width: 650px">
          <div class="row col justify-content-end">
            <button type="button" class="close" @click="currVideo = null" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="w-100"></div>
          <iframe width="560" height="315" :src="currVideo" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
            style="max-width: 800px"></iframe>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div v-if="notification || showNotificationHistory">
        <div v-if="notification" class="modal nb-modal-mask" style="display: block;">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document"
            style="overflow-y: initial !important">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="def-title" id="exampleModalLabel">Mensagem</h4>
              </div>
              <div class="modal-body" style="max-height: 255px; overflow-y: auto">
                <div>
                  <span class="card shadow-sm ">
                    <div class="card-header bg-transparent d-flex justify-content-between align-items-center">
                      <h2 class="title">
                        <span class="mr-3" style="font-size: 18px">
                          #{{ notification.codnotificacao }}
                        </span>
                        {{ notification.assunto }}
                      </h2>
                    </div>
                    <div class="card-body">
                      <span v-if="notification.mensagem">{{
                          notificationMsg
                      }}</span>
                      <span v-else>Não há mensagem</span>
                      <br />
                      <div class="w-100 d-flex justify-content-end my-2">
                        <small style="color: #2b6292; font-size: 14px; font-weight: 700">Data: {{ notification.data |
                            formatDataHora
                        }}</small>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" v-if="!backToNotificationHistoryModal ? true : false" :title="
                  backToNotificationHistoryModal
                    ? 'Notificação já está marcada como lida'
                    : ''
                " ref="btnConfirm" class="btn btn-success btn-sm" @click="handleConfirmNotification()">
                  <i class="fa fa-check"></i>
                  Marcar como lida
                </button>
                <button type="button" ref="btnClose" class="btn btn-secondary btn-sm" data-dismiss="modal"
                  @click="handleCloseNotification()">
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
        <NotificationHistory v-if="showNotificationHistory" @close="handleCloseNotificationHistory()"
          @view="handleShowViewNotification($event)" @cancel="handleCancelNotification($event)" />
      </div>
    </transition>

    <!-- GUIA -->
    <transition name="fade">
      <ConfigGuia v-if="configGuide" @close="handleConfigModal" />
    </transition>
  </header>
</template>

<style scoped>
.title {
  font-size: 25px;
  font-weight: 600;
  color: #2b6292;
}

.card-body span {
  font-size: 15px;
  font-weight: 600;
  color: #5c5c5c;
  white-space: pre-line;
}

.nb-menu-config {
  color: #9c9a9a;
  font-size: 18px;
}

.nb-menu-config:hover {
  color: #fff;
}

.nb-menu-title {
  color: #fff;
  font-size: 15px;
  padding: 0.5rem 1.5rem;
  background-color: #2b6292;
}

.nb-dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  color: #c2c4c5;
  font-size: 85%;
  background: #2b6292;
  white-space: nowrap;
  text-align: center;
}

.columns-1 {
  min-width: 250px;
}

.columns-2 {
  min-width: 525px;
}

.columns-3 {
  min-width: 700px;
}

.left-divider {
  overflow: hidden;
  border-left: 1px solid #e9ecef;
}

.nb-dropdownmenu {
  /* background: #ffffff; */
  /* width: 100%; */
  margin-left: auto;
}

.nb-dropdownmenu ul,
.nb-dropdownmenu li {
  margin: 0;
  padding: 0;
}

.nb-dropdownmenu ul {
  background: #ffffff;
  list-style: none;
  /* width: 100%; */
}

.nb-dropdownmenu li {
  float: left;
  position: relative;
  width: auto;
}

.nb-dropdownmenu li:hover a {
  background: #2b6292;
  color: #ffffff;
}

.nb-dropdown-divider {
  background: #2b6292;
  width: 1;
  overflow: hidden;
  border-bottom: 1px solid #e9ecef;
}

#submenu {
  position: absolute;
  left: 0;
  opacity: 0;
  padding: 0.5rem;
  visibility: hidden;
  background: #2b6292;
  z-index: 1000;
}

li:hover ul#submenu {
  opacity: 1;
  top: 40px;
  /* adjust this as per top nav padding top & bottom comes */
  visibility: visible;
}

#submenu li {
  float: none;
  width: 100%;
}

#submenu a:hover {
  background: #2b629285;
}

#submenu a {
  background-color: #2b6292;
}

.nb-help-video-icon {
  display: inline-flex;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  color: #ef4444;
  background: #fef2f2;
  border-radius: 5px;
  font-size: 13px;
  vertical-align: middle;
}

#submenu .row {
  background: #2b6292;
  margin-right: 0;
  margin-left: 0;
}

#submenu .submenu-col-2 {
  flex: 0 0 50%;
  max-width: 50%;
}

#submenu .submenu-col-3 {
  flex: 0 0 33.33%;
  max-width: 33.33%;
}

#submenu.submenu-right {
  right: 0;
  left: auto;
}

.notification {
  max-height: 400px;
  overflow: auto;
}

.notification-text {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

#badge {
  position: absolute;
  top: -3px;
  left: 20px;
  width: 20px;
  height: 20px;
  line-height: 5px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px !important;
}

#badge-mobile {
  width: 23px;
  height: 23px;
  line-height: 10px;
}

.mobile-device {
  display: block;
}

.other-device {
  display: none;
}

@media (min-width: 768px) {
  .mobile-device {
    display: none;
  }

  .other-device {
    display: block;
  }
}

.submenu-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  color: gray;
  /* font-size: 85%; */
  /* background:#2b6292; */
  font-weight: 700;
  white-space: nowrap;
  text-align: center;
}

.menu-user {
  color: #fff;
  font-size: 0.75rem;
  background: #2b6292;
}

.menu-email {
  display: block;
  padding: 0.5rem;
  margin-bottom: 0;
  color: #fff;
  font-size: 85%;
  background: #2b6292;
  /* white-space: nowrap; */
  /* text-align: center; */
}

.menu-user i,
.menu-email i {
  font-size: 0.85rem;
  padding: 0.25rem;
}

#btn-exit:hover {
  background-color: #2b629285 !important;
}

.close {
  font-size: 5rem;
}

/* alterados */
.nb-dropdownmenu a {
  background: #ffffff;
  /* color: #2b6292; */
  color: gray;
  display: block;
  font-size: 12px;
  /* font-weight: 600; */
  line-height: 40px;
  text-transform: uppercase;
  /* letter-spacing: 0.3px; */
  padding: 0px 10px;
  text-decoration: none;
  white-space: nowrap;
  -webkit-transition: all 0.25s ease;
  -moz-transition: all 0.25s ease;
  -ms-transition: all 0.25s ease;
  -o-transition: all 0.25s ease;
  transition: all 0.25s ease;
}

.nb-dropdownmenu a:hover {
  color: #fff;
}

/* BREAKPOINT MOBILE MENU */
@media screen and (max-width: 992px) {
  .navbar-desktop {
    display: none;
  }

  .navbar-mobile {
    display: flex !important;
  }

  /* MENU HAMBURGER STYLE AND ANIMATION */
  .hamburger {
    width: 55px;
    height: 45px;
    padding: 0.75rem;
    display: flex !important;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    transition: transform 330ms ease-out;
    z-index: 999 !important;
  }

  .hamburger.active {
    transform: rotate(-45deg);
    width: 25px;
    height: 25px;
    padding: 0;
    margin-right: 0.75rem;
  }

  .line-menu {
    background-color: #808080;
    border-radius: 5px;
    width: 100%;
    height: 3px;
  }

  .line-menu.half {
    width: 50%;
  }

  .line-menu.start {
    transition: transform 330ms cubic-bezier(0.54, -0.81, 0.57, 0.57);
    transform-origin: right;
  }

  .active .line-menu.start {
    transform: rotate(-90deg) translateX(2px);
  }

  .line-menu.end {
    align-self: flex-end;
    transition: transform 330ms cubic-bezier(0.54, -0.81, 0.57, 0.57);
    transform-origin: left;
  }

  .active .line-menu.end {
    transform: rotate(-90deg) translateX(-2px);
  }

  .wrapper {
    display: flex !important;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: fixed;
    top: 60px;
    left: -100%;
    padding: 0 1rem;
    width: 80%;
    height: calc(100vh - 60px) !important;
    transition: 0.5s ease;
    overflow-y: auto;
    scrollbar-width: none;
    z-index: 999 !important;
  }

  .wrapper.active {
    left: 0;
  }

  .accordion {
    background-color: transparent;
    color: #444;
    cursor: pointer;
    padding: 0.5rem;
    width: 100%;
    text-align: left;
    border: none;
    outline: none;
  }

  .accordion i {
    font-size: 0.75rem;
  }

  /* .active, .accordion:hover {
    background-color: #ccc;
  } */

  .panel {
    padding: 0 1rem;
    background-color: #f6f6f6;
    overflow: hidden;
    width: 100%;
    transition: max-height 0.5s;
  }

  .panel p {
    margin: 0;
    padding: 0.5rem 0.25rem;
    font-size: 0.85rem;
  }
}

.bell {
  -webkit-animation: ring 4s 0.7s ease-in-out infinite;
  -webkit-transform-origin: 50% 4px;
  -moz-animation: ring 4s 0.7s ease-in-out infinite;
  -moz-transform-origin: 50% 4px;
  animation: ring 4s 0.7s ease-in-out infinite;
  transform-origin: 50% 4px;
}

@-webkit-keyframes ring {
  0% {
    -webkit-transform: rotateZ(0);
  }

  1% {
    -webkit-transform: rotateZ(30deg);
  }

  3% {
    -webkit-transform: rotateZ(-28deg);
  }

  5% {
    -webkit-transform: rotateZ(34deg);
  }

  7% {
    -webkit-transform: rotateZ(-32deg);
  }

  9% {
    -webkit-transform: rotateZ(30deg);
  }

  11% {
    -webkit-transform: rotateZ(-28deg);
  }

  13% {
    -webkit-transform: rotateZ(26deg);
  }

  15% {
    -webkit-transform: rotateZ(-24deg);
  }

  17% {
    -webkit-transform: rotateZ(22deg);
  }

  19% {
    -webkit-transform: rotateZ(-20deg);
  }

  21% {
    -webkit-transform: rotateZ(18deg);
  }

  23% {
    -webkit-transform: rotateZ(-16deg);
  }

  25% {
    -webkit-transform: rotateZ(14deg);
  }

  27% {
    -webkit-transform: rotateZ(-12deg);
  }

  29% {
    -webkit-transform: rotateZ(10deg);
  }

  31% {
    -webkit-transform: rotateZ(-8deg);
  }

  33% {
    -webkit-transform: rotateZ(6deg);
  }

  35% {
    -webkit-transform: rotateZ(-4deg);
  }

  37% {
    -webkit-transform: rotateZ(2deg);
  }

  39% {
    -webkit-transform: rotateZ(-1deg);
  }

  41% {
    -webkit-transform: rotateZ(1deg);
  }

  43% {
    -webkit-transform: rotateZ(0);
  }

  100% {
    -webkit-transform: rotateZ(0);
  }
}

@-moz-keyframes ring {
  0% {
    -moz-transform: rotate(0);
  }

  1% {
    -moz-transform: rotate(30deg);
  }

  3% {
    -moz-transform: rotate(-28deg);
  }

  5% {
    -moz-transform: rotate(34deg);
  }

  7% {
    -moz-transform: rotate(-32deg);
  }

  9% {
    -moz-transform: rotate(30deg);
  }

  11% {
    -moz-transform: rotate(-28deg);
  }

  13% {
    -moz-transform: rotate(26deg);
  }

  15% {
    -moz-transform: rotate(-24deg);
  }

  17% {
    -moz-transform: rotate(22deg);
  }

  19% {
    -moz-transform: rotate(-20deg);
  }

  21% {
    -moz-transform: rotate(18deg);
  }

  23% {
    -moz-transform: rotate(-16deg);
  }

  25% {
    -moz-transform: rotate(14deg);
  }

  27% {
    -moz-transform: rotate(-12deg);
  }

  29% {
    -moz-transform: rotate(10deg);
  }

  31% {
    -moz-transform: rotate(-8deg);
  }

  33% {
    -moz-transform: rotate(6deg);
  }

  35% {
    -moz-transform: rotate(-4deg);
  }

  37% {
    -moz-transform: rotate(2deg);
  }

  39% {
    -moz-transform: rotate(-1deg);
  }

  41% {
    -moz-transform: rotate(1deg);
  }

  43% {
    -moz-transform: rotate(0);
  }

  100% {
    -moz-transform: rotate(0);
  }
}

@keyframes ring {
  0% {
    transform: rotate(0);
  }

  1% {
    transform: rotate(30deg);
  }

  3% {
    transform: rotate(-28deg);
  }

  5% {
    transform: rotate(34deg);
  }

  7% {
    transform: rotate(-32deg);
  }

  9% {
    transform: rotate(30deg);
  }

  11% {
    transform: rotate(-28deg);
  }

  13% {
    transform: rotate(26deg);
  }

  15% {
    transform: rotate(-24deg);
  }

  17% {
    transform: rotate(22deg);
  }

  19% {
    transform: rotate(-20deg);
  }

  21% {
    transform: rotate(18deg);
  }

  23% {
    transform: rotate(-16deg);
  }

  25% {
    transform: rotate(14deg);
  }

  27% {
    transform: rotate(-12deg);
  }

  29% {
    transform: rotate(10deg);
  }

  31% {
    transform: rotate(-8deg);
  }

  33% {
    transform: rotate(6deg);
  }

  35% {
    transform: rotate(-4deg);
  }

  37% {
    transform: rotate(2deg);
  }

  39% {
    transform: rotate(-1deg);
  }

  41% {
    transform: rotate(1deg);
  }

  43% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bar-top.vue